<template>
    <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
          Lighting
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            <span v-for="(content, index) in contents" :key="content['id']">
               {{ section }}.{{ index + 1 }} {{ content.question }} <br>
               Answer: {{ forms.lighting_score[index] ? 'Yes' : 'No' }} <br>
               Comment: {{ forms.lighting_comment[index] }} <br> <br>
            </span>
        </div> 
    </v-container>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section','forms'],
    data(){
        return{
            contents:[
                {
                    question: "Are overhead lights positioned that they do not create shadows on the workstation?",
                    parts: ['General']
                },
                {
                    question: "Is there workstation oriented at 90 degree from window?",
                    parts: ['General']
                },
                {
                    question: "Are there any curtains/blinds to reduce glare from windows?",
                    parts: ['General']
                },
                {
                    question: "Is the workstation between rows of overhead lights?",
                    parts: ['General']
                },
            ]
        }
    },
    methods:{
  
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.lighting_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

